module.exports = __webpack_public_path__ + "static/media/md-star-outline.2c1d0c71.svg";